/**
 * AppFooter - Statusleiste mit Produktname und laufender Version
 *
 * Sitzt fest am unteren Rand und ist damit immer sichtbar, egal wie weit die
 * Seite gescrollt ist. Sie überdeckt keinen Inhalt: die aufrufenden Layouts
 * halten unten genau ihre Höhe frei (`pb-*`).
 *
 * Eingehängt in Admin-Bereich, Techniker-Bereich und den Kiosk-Screen der
 * Stationen. Die Anmelde- und Einladungsseiten haben bewusst keine Leiste.
 *
 * `position` bestimmt, wo die Leiste sitzt - das weiß nur das jeweilige
 * Layout: im Admin-/Technikbereich über der mobilen Navigationsleiste und
 * rechts neben der Seitenleiste, im Kiosk über die volle Breite.
 *
 * `kontext` ist die Zusatzangabe hinter dem Produktnamen - an der Station der
 * Name der Station bzw. die Erfassungsart.
 */

import { useAppVersion } from '../hooks/useAppVersion';

interface AppFooterProps {
  kontext?: string;
  position?: string;
}

/** Höhe der Leiste: py-2 + Textzeile. Passend dazu die pb-* der Layouts. */
export const APP_FOOTER_KLASSEN =
  'bg-flaeche border-t px-4 py-2 lg:px-6 text-xs text-tinte-3 lg:text-sm';

export function AppFooter({ kontext, position = 'fixed inset-x-0 bottom-0 z-40' }: AppFooterProps) {
  const version = useAppVersion();

  return (
    <footer className={`${position} ${APP_FOOTER_KLASSEN}`} data-testid="app-footer">
      <p className="text-center tabular-nums">
        <span>wash-ops</span>
        {kontext && <span> • {kontext}</span>}
        {version && (
          <span data-testid="app-version">
            {' '}
            • v{version.version} · {version.commit}
          </span>
        )}
      </p>
    </footer>
  );
}
